import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import LotDetail, { formatLotCode } from '../../shared/lots/LotDetail.js';
import DetailWhatsAppTip from '../../shared/DetailWhatsAppTip.js';
import { herdLotTips } from '../../shared/whatsappTips.js';

export const HerdLotDetail = () => {
  const { lotId } = useParams();
  const { t }     = useTranslation();
  const [lot, setLot] = useState(null);

  useEffect(() => {
    Fetch(`api/data/lots?search_fields=type,lot_id&search_values=herd,${lotId}`, 'get', null,
      (data) => setLot((data || [])[0] || null)
    );
  }, [lotId]);

  if (!lot) return <div className="wl-empty-note" style={{ padding: 24 }}>…</div>;

  return (
    <LotDetail
      lot={lot}
      prefix={t('herd_lot_prefix')}
      basePath="/herd/lots"
      onFieldSaved={(field, value) => setLot(prev => ({ ...prev, [field]: value }))}
      animalsTo="/herd/animals"
      animalsState={{ lotFilter: lot.lot_id }}
      whatsappTip={<DetailWhatsAppTip title={t('lot_tip_title')}
        tips={herdLotTips(formatLotCode(lot.lot_id, t('herd_lot_prefix')), t)} />}
    />
  );
};

export default HerdLotDetail;
